import { Component,  ViewChild, ElementRef,ChangeDetectorRef } from '@angular/core';

import {LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';
import * as moment from 'moment';
import 'leaflet';
import {MainPage} from "../main/main";
import {RealtimePage} from "../realtime/realtime";
import {DeviceMsgService} from "../../services/deviceMsg.service";
import { Storage } from '@ionic/storage';
import {AuthService} from "../../services/auth.service";
import {LoginPage} from "../login/login";
import {GlobalVariable} from "../../services/global.vars";
import {UtilsService} from "../../services/utils.service";
import {SensorUtilService} from "../../services/sensors.service";

declare var require: any;
var hcharts = require('highcharts');
require('highcharts/modules/exporting')(hcharts);

@Component({
  selector: 'page-historic',
  templateUrl: 'historic.html'
})
export class HistoricPage{

  @ViewChild('chart') canvas: ElementRef;
  private asset: any = {};
  private map: any;
  private event: any;
  private sensor: any;
  private moment: any;
  private sensors: any= [];
  private showChart:Boolean;
  private baseLayers: any;
  private baseLayersKeys:any = [];
  private loading: any;
  private canGoBack: boolean = false;
  private histoLayer : any;
  private markersLayer: any;
  private selectedStopLayer: any;

  private selectedTrajet:any;
  private currentStepSimulation:any;


  private trajets: any = [];
  private paths: any = [];
  private dates: any = [];
  private sensorOdo: any;
  private pathListshown: boolean;

  constructor(public navCtrl: NavController,
              public loadingCtrl: LoadingController,
              private deviceMsgService : DeviceMsgService,
              private authService : AuthService,
              private utilsService : UtilsService,
              private sensorUtilService : SensorUtilService,

              private toastCtrl: ToastController,
              public storage: Storage,
              private cdr: ChangeDetectorRef,
              navParams: NavParams) {
    //Getting the asset object from navigation parameters
    this.asset = navParams.get('asset');
    this.showChart = false;
    this.canGoBack = navParams.get('canGoBack');

    this.histoLayer = new L.LayerGroup();
    this.markersLayer = new L.LayerGroup();
    this.selectedStopLayer = new L.LayerGroup();
    this.pathListshown = false;
    this.moment = moment;



    hcharts.createElement('link', {
      href: 'https://fonts.googleapis.com/css?family=Dosis:400,600',
      rel: 'stylesheet',
      type: 'text/css'
    }, null, document.getElementsByTagName('head')[0]);


    hcharts.theme = {
      colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
        '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
      chart: {
        backgroundColor: null,
        style: {
          fontFamily: 'Dosis, sans-serif'
        }
      },
      title: {
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          textTransform: 'uppercase'
        }
      },
      tooltip: {
        borderWidth: 0,
        backgroundColor: '#0040cc',
        style: {
          color: '#ffffff'
        },
        shadow: false
      },
      legend: {
        itemStyle: {
          fontWeight: 'bold',
          fontSize: '13px',
          color:"#ffffff"
        }
      },
      xAxis: {
        labels: {
          style: {
            fontSize: '12px',
            color:"#ffffff"
          }
        }
      },
      yAxis: {
        title: {
          style: {
            textTransform: 'uppercase',
            color:"#ffffff"
          }
        },
        labels: {
          style: {
            fontSize: '12px',
            color:"#ffffff"
          }
        }
      },

      plotOptions: {
        series: {
          color: "#ffffff"
        }
      },


      // General
      background2: 'transparent'

    };

    // Apply the theme
    hcharts.setOptions(hcharts.theme);



  }
  ngAfterViewChecked(){
    //your code to update the model
    this.cdr.detectChanges();
  }
  private selectedBaseLayerKey: string;
  private HIDE_DISPUTED_BOUNDARIES=GlobalVariable.HIDE_DISPUTEDBOUNDARIES?"&apistyle=s.t:17|s.e:all|p.v:off":"";

  public baseLayer : any = {
    NGI: L.tileLayer.wms(GlobalVariable.TILE_URL, {
      maxZoom: 19,
      name: "NGI",
      attribution: 'Powered iaxeed',
      icon: 'ngiMap.png'
    }),
    googleRoadmap: L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Map",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gNorm.png'

    }),

    googleTerrain: L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Satellite",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gSat.png'

    }),
    googleHybrid: L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Hybride",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gHybr.png'

    }),
    osm: L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      name: "Open Street",
      icon: 'osmMap.png'

    })
  };

  initMap(){
    this.map.options.attributionControl = true;
    this.map.attributionControl.setPrefix('');
    this.map.whenReady(()=>{
      this.storage.ready().then(()=>{
        this.storage.get('baselayer').then((baselayer)=>{
          this.changeBaseLayer(baselayer);
        })
      })
    })
  }

  createPaths(data, filter_drive, filter_stop){

    let trajet: any = {};
    let latlng:any = {};
    let countDrive  = 0;
    let countStops  = 0;
    //let filter = 0;
    let endTrajet = false;
    let duree=0;
    let lastStop=[];
    this.trajets =[];
    this.histoLayer.clearLayers();

    let  previouslatlang={};
    let i = 0;
    let j = 0;



    if(data.length > 0){
      let index = 1;
      while(i< data.length){

        if(data[i].io != undefined && data[i].io.con !== undefined && data[i].gps_dt != undefined 
          && data[i].loc !== undefined && data[i].loc !== null && data[i].loc.coordinates.length>0 ){
          trajet = {};
          trajet.coordinates = [];
          trajet.index = index;
          index++;

          trajet.Start = data[i];
          trajet.paths = [];
          if(data[i].io.con === 1){
            trajet.state = 'drive';
            //filter = filter_drive;
            trajet.order = countDrive; //count number trajet drive
            countDrive++;
            latlng = {lat: trajet.Start.loc.coordinates[1], lng: trajet.Start.loc.coordinates[0]};

            if(lastStop.length>0) {
              previouslatlang = {lat: lastStop[0], lng: lastStop[1]};
              if (this.calculDistance(latlng, previouslatlang)) {
                trajet.coordinates.push(previouslatlang); // add lat/lang to cordiantes Liste
              }

            }
            trajet.paths.push(trajet.Start);
            trajet.coordinates.push(latlng); // add lat/lang to cordiantes Liste
            lastStop=[];

          }else{
            trajet.state = 'stop';
            trajet.paths.push(trajet.Start);
            trajet.order = countStops; //count number stops
            latlng = {lat: trajet.Start.loc.coordinates[1], lng: trajet.Start.loc.coordinates[0]};
            trajet.coordinates.push(latlng); // add lat/lang to cordiantes Liste
            countStops++;
            lastStop = [trajet.Start.loc.coordinates[1],trajet.Start.loc.coordinates[0]];

          }

          j = i + 1;
          endTrajet = false;

          while(j < data.length && !endTrajet) { // while 2
            if (data[j].io !== undefined && data[j].io.con !== undefined && data[j].gps_dt !== undefined && data[j].loc !== undefined && data[j].loc.coordinates.length > 0) {

              if (j < data.length - 1) {
                //filter time
                duree = this.dateDiff(trajet.Start.gps_dt, data[j].gps_dt);
                //if (duree.min >= filter) {
                if ((data[j].io.con === trajet.Start.io.con)) {// add to path
                  trajet.paths.push(data[j]);
                  latlng = {
                    lat: data[j].loc.coordinates[1],
                    lng: data[j].loc.coordinates[0]
                  };
                  trajet.coordinates.push(latlng);
                  j++;
                } else {//end trajet
                  trajet.paths.push(data[j]);
                  trajet.End = data[j];
                  latlng = {
                    lat: data[j].loc.coordinates[1],
                    lng: data[j].loc.coordinates[0]
                  };
                  trajet.coordinates.push(latlng);
                  endTrajet = true;
                }
              } else {// end of Liste
                if (data[j].io.con === trajet.Start.io.con) {
                  trajet.paths.push(data[j]);
                  latlng = {
                    lat: data[j].loc.coordinates[1],
                    lng: data[j].loc.coordinates[0]
                  };
                  trajet.coordinates.push(latlng);

                  trajet.End = data[j];
                  endTrajet = true;
                  j++;
                }
                else {


                  trajet.paths.push(data[j]);
                  trajet.End = data[j - 1];
                  latlng = {
                    lat: data[j].loc.coordinates[1],
                    lng: data[j].loc.coordinates[0]
                  };
                  trajet.coordinates.push(latlng);
                  endTrajet = true;
                }
              }
            } else {
              if (j === data.length - 1) {//end trajet j-1
                trajet.End = data[j];
                latlng = {
                  lat: trajet.End.loc.coordinates[1],
                  lng: trajet.End.loc.coordinates[0]
                };
                trajet.coordinates.push(latlng);
                endTrajet = true;
              } else
                j++;

            }
          }
            if (trajet.Start && trajet.End) {

              trajet.duree = this.dateDiff(trajet.Start.gps_dt, trajet.End.gps_dt);
              if (trajet.state === 'drive') {
                trajet.distance = this.calculDistanceTrajet(trajet,this.sensorOdo);
                let speedValues =  this.calculSpeedTrajet(trajet);
                trajet.avgSpeed = speedValues.avgSpeed;
                trajet.maxSpeed = speedValues.maxSpeed;

              }
              else {
                trajet.distance = null;
              }
              this.trajets.push(trajet);

            }
            else if(trajet.Start){
              let edDate  = this.dates.endDate;
              trajet.End  = {gps_dt:edDate};
              trajet.duree = this.dateDiff(trajet.Start.gps_dt, edDate);
              trajet.distance = 0;
              trajet.isLast=true;
              this.trajets.push(trajet);
              endTrajet = true;
            }

            i = j;
          }


         else {
          i++;
        }
      }
    }
  }
   calculDistance(lngLat1, lngLat2) {
     let distance = 200;
     let isNear = false;
    let lat1 = lngLat1.lat;
     let lng1 = lngLat1.lng;
     let lat2 = lngLat2.lat;
     let lng2 = lngLat2.lng;
     let R = 6371; // Radius of the earth in km
     let dLat = (lat2 - lat1) * (Math.PI / 180);  // deg2rad below
     let dLon = (lng2 - lng1) * (Math.PI / 180);
     let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
     let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
     let d = R * c * 1000; // Distance in m
    if (d < distance)
      isNear = true;
    return isNear;
  }
  calculDistanceTrajet(trajet, sensor) {
    let distance = 0;
    if(sensor && sensor.isAbsolute ){
      let startOdo=-1;
      let  endOdo=-1;
      let i=0;
      while((startOdo<0 ||  endOdo<0)  && i<trajet.paths.length){

        if(startOdo<0 && Number.isFinite(trajet.paths[i].odo)){
          startOdo=trajet.paths[i].odo;
        }

        if(endOdo<0 && Number.isFinite(trajet.paths[trajet.paths.length-1-i].odo)){
          endOdo=trajet.paths[trajet.paths.length-1-i].odo;
        }
        i++
      }
      if(startOdo >=0 && endOdo>=0 && startOdo<=endOdo){
        distance= endOdo -startOdo;
      }


    }else {
      for(let item of trajet.paths) {
        if (item.io.odo)
          distance += item.io.odo / 1000
      }
    }
    return distance;
  }
  calculSpeedTrajet(trajet) {
    let maxSpeed = 0;
    let avgSpeed = 0;
    let speedSum =0;
    let speedNum = 0;
    for(let item of trajet.paths){
      if (item.io.spd) {
        if (item.io.spd > maxSpeed)
          maxSpeed = item.io.spd;
        speedSum = speedSum + item.io.spd;
        speedNum++;

      }
    }
    if(speedSum>0)
      avgSpeed = speedSum/speedNum;
    let speedValues ={maxSpeed:maxSpeed,avgSpeed:avgSpeed};
    return speedValues;
  }

  dateDiff(date1, date2) {
    let diff : any = {sec: '00', min: '00', hour: '00', day:'00'};// now// Initialisation du retour

    let tmp = moment(date2,"YYYY-MM/DD HH:mm:ss").diff(moment(date1,"YYYY-MM/DD HH:mm:ss"));
    tmp = Math.floor(tmp / 1000);             // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60;                    // Extraction du nombre de secondes
    diff.sec = ('0' + diff.sec).slice(-2);

    tmp = Math.floor((tmp - diff.sec) / 60);    // Nombre de minutes (partie entière)
    diff.min = tmp % 60;
    diff.min = ('0' + diff.min).slice(-2);// Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff.min) / 60);    // Nombre d'heures (entières)
    diff.hour = tmp % 24;
    diff.hour = ('0' + diff.hour).slice(-2);// Extraction du nombre d'heures

    tmp = Math.floor((tmp - diff.hour) / 24);   // Nombre de jours restants
    diff.day = tmp;
    return diff;

  }

  getAddress() {
    let addressCoordinates =[];
    let poiCoordinates =[];
    if (this.trajets.length > 0) {
      for(let item of this.trajets) {
        if (item.state === 'drive') {
          if(item && item.Start && item.Start.loc && item.Start.loc.coordinates && item.End && item.End.loc && item.End.loc.coordinates){
            addressCoordinates.push([item.Start.loc.coordinates[0], item.Start.loc.coordinates[1]]);
            addressCoordinates.push([item.End.loc.coordinates[0], item.End.loc.coordinates[1]])
          }
        }
        if (item.state === 'stop') {
          if(item && item.Start && item.Start.loc && item.Start.loc.coordinates && item.End && item.End.loc && item.End.loc.coordinates){
            addressCoordinates.push([item.Start.loc.coordinates[0], item.Start.loc.coordinates[1]]);
            poiCoordinates.push([item.Start.loc.coordinates[0], item.Start.loc.coordinates[1]])
          }
        }
      }
      if (addressCoordinates.length > 0) {
        this.utilsService.getAddress(addressCoordinates).subscribe((response) => {
          let res = [];

          if (response && response.BND && response.BND.BatchResults){
            if (response.BND.BatchResults.length > 0) {
              for(let value of  response.BND.BatchResults){
                if (value.Elements.count > 0) {
                  let element = value.Elements.Element[0];
                  let address = this.utilsService.format(element);

                  res.push(address)
                } else{
                  res.push('Not available')
                }
              }
            }
          }
          let i = 0;
          for(let elem of this.trajets){
            if (elem.state === 'drive') {
              elem.Start.address = res[i];
              elem.End.address = res[i+1];
              i++;

            }
            else{
              elem.Start.address = res[i];

            }

            i++;
          }

        }, function (error) {
          console.log(error);
        })

      }
    }
  }


  showTrajet(trajet, index, position) {
    this.selectedTrajet = trajet;
    this.currentStepSimulation = index;
    this.selectedStopLayer.clearLayers();

    this.markersLayer.clearLayers();
    // drive state
    if (trajet.state === 'drive') {
      // histoUtilsSrv.ChangeSelectedPath("drive_" + trajet.order);
      this.paths[trajet.index] = {};
      this.paths[trajet.index].color = "#003366";

      this.paths[trajet.index].weight = 7;
      this.paths[trajet.index].opacity = 1;
      let markers = [];
      let angle = 0;
      //show marker trajet
      for(let item of trajet.paths){
        let color = "blue";
        let speed = 0;

        let iconDirection = "speed_0.png";
        if (item.io.spd) {

          speed = item.io.spd;
          if (speed < 80)
            iconDirection = "speed_1.png";
          else if (speed < 120)
            iconDirection = "speed_2.png";
          else
            iconDirection = "speed_3.png";
        }
        let content = '<div class="map-popup"><div class="popup-details">'
          + '<div><img src="assets/speed.png" style="width: 16px;height: 16px"/><b> Vitesse</b> ' + speed + ' Km/h</div>'
          + '<div><img src="assets/icon-time.png" style="width: 16px;height: 16px"/><b> Date</b> ' + moment.utc(item.gps_dt).format('DD/MM/YYYY HH:mm:ss') + '</div>'
          + '</div>';


        if (item.io.ang)
          angle = item.io.ang;

        let elem = {
          angle: angle,
          iconDirection: iconDirection,
          color: color,
          content: content,
          lat: item.loc.coordinates[1],
          lng: item.loc.coordinates[0]

        };
        markers.push(elem);
      }

      //  trajet.pathHisto = pathHisto;
      //  zoom to selected path;
      let  bounds = new L.LatLngBounds(trajet.coordinates);

      if (position !== null) {
        bounds = new L.LatLngBounds([position.coordinates[1], position.coordinates[0]]);
      }

      this.map.fitBounds(bounds);
      this.drawMarkers(markers);
      this.ChangeSelectedPath("drive_" + trajet.index);

    } else {
      let coordinates = trajet.coordinates[0];
      this.map.setView([coordinates.lat, coordinates.lng], 19);
      this.ChangeSelectedStop(coordinates);

      this.histoLayer.eachLayer(function (elem) {
        if(elem.options.myId){
          elem.setStyle({
            color: '#0044FA',
            weight: 3
          });
        }

      });
    }


  };

  showPathsList(){
    this.showChart = true;
    this.pathListshown =  !this.pathListshown;
  }

  ChangeSelectedPath(layerId) {
    this.histoLayer.eachLayer(function (elem) {
      if (elem.options["myId"] === layerId) {
        elem.setStyle({
          color: '#44C565',
          weight: 5
        });
        elem.bringToFront()
      } else {
        if(elem.options.myId){
          elem.setStyle({
            color: '#0044FA',
            weight: 3

          });
        }

      }

    });
  };
  ChangeSelectedStop(position) {
    let cssIcon = L.divIcon({
      className: 'css-icon',
      html: '<div class="gps_ring"></div>',
      iconSize: [22,22]
    });
    L.marker([position.lat, position.lng], {icon: cssIcon,
      zIndexOffset:-1}).addTo(this.selectedStopLayer)

  };

  drawMarkers(markers) {
    for(let item of markers) {
      let directionIcon = L.divIcon({
        html: '<img src="assets/' + item.iconDirection + '" style="width: 30px; height: 62px;transform: rotate(' + item.angle + 'deg);  -webkit-transform: rotate(' + item.angle + 'deg); -moz-transform:rotate(' + item.angle + 'deg);" />',
      });
      let marker = L.marker([item.lat, item.lng], {
        icon: directionIcon
      }).addTo(this.markersLayer)
        .bindPopup(item.content);
      marker.on('mouseover', function(){
        this.openPopup();
      });
      marker.on('mouseout', function () {
        this.closePopup();
      });

    }
  }


  changeBaseLayer(key) {
    for (let k in this.baseLayer) {
      if (this.map.hasLayer(this.baseLayer[k])){
        this.map.removeLayer(this.baseLayer[k]);
      }
    }

    this.storage.ready().then(()=>{
      this.storage.set('baselayer', key).then(()=>{
        this.storage.get('baselayer').then((bLayer)=>{
          this.selectedBaseLayerKey = bLayer;
          this.map.addLayer(this.baseLayer[bLayer]);
        })
      });
    });

  };

  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'Aucun message d\'appareil n\'a été trouvé pour la période sélectionnée !',
      position: 'bottom',
      showCloseButton: true
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  ngOnInit() {
    this.event = {
      startDate :moment().startOf('day').clone().format(),
      endDate : moment().clone().format()
    };
    this.baseLayers = this.baseLayer;
    this.baseLayersKeys = Object.keys(this.baseLayers);
    this.map = new L.Map('mapHisto', {
      zoom: 5,
      scrollWheelZoom:'center'
    });
    this.initMap();
    this.loadChart();
  }

  getSecondsQuery(){

    return {

      "project": {
        "y": {"$year":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}},
        "m": {"$month":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}},
        "d": {"$dayOfMonth":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}},
        "h": {"$hour":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}}  ,
        "mm":  {"$minute":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}},
        "ss":{"$second":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}}   ,
        "ms": {"$millisecond":{"$add":["$gps_dt",moment().utcOffset()*60*1000]}}

      },
      "group": {
        "y": "$date.y",
        "m": "$date.m",
        "d": "$date.d",
        "h": "$date.h",
        "mm": "$date.mm",
        "ss": "$date.ss",
        "ms": "$date.ms"
      }}
  }

  BuildQueryByPeriod(startDate,endDate){
    startDate = moment(startDate);
    endDate = moment(endDate);

    return this.getSecondsQuery();
  }

  getQuery(startDt, endDt){
    let self = this

    self.sensorOdo = null;

    var sensors = self.asset.sensors;
    if(sensors && sensors.length>0) {
      for (let sensor of sensors) {
        if (sensor.type === "ODOMETER") {
          self.sensorOdo = sensor;
        }

      }

    }

    var startDate = moment.utc(startDt );
    var endDate = moment.utc(endDt );
    let agg = self.BuildQueryByPeriod(startDate, endDate);
    return {
      query: [
        {
          "$match": {
            "_asset": self.asset._id,
            gps_dt: {
              $gte: startDate.toDate(),
              $lte: endDate.toDate()
            }
          }
        }, {
          "$project": {
            "date1": "$gps_dt",
            "io": "$io",
            "loc": "$loc",
            "odo": self.getOdoSensorQuery(this.asset),

            "gps_dt": {"$add": ["$gps_dt", moment().utcOffset() * 60 * 1000]},
            "date": agg.project
          }
        },
        {
          "$group": {
            "_id": agg.group,
            "data": {
              $push: {
                loc: "$loc",
                io: "$io",
                "odo": "$odo",

                gps_dt: "$gps_dt"
              }
            },
            "count": {"$sum": 1}
          }
        },
        {"$sort": {"_id": 1}}


      ]
    }
  }

  loadChart(sensor?) {

    this.loading = this.loadingCtrl.create({
      content: 'Veuillez patientez...'
    });
    this.loading.present();

    let data = [];
    let path = [];
    let latlang = {};
    let series = [];



    this.storage.ready().then(()=> {
      this.deviceMsgService.getDeviceMsgAgg(this.getQuery(this.event.startDate,this.event.endDate),10000,0).subscribe(dm => {
        let histoData = [];
        if(dm && dm.length>0){



          for(let value of dm){

            if (value && value.data && value.data.length > 0) {
              for(let elem of value.data) {
                histoData.push(elem)
              }
            }
          }


          if(this.sensors.length  <= 0){
            this.sensors = [];
            if(Number.isFinite(dm[0].data[0].io.spd)){
              this.sensors.push({'name':'Vitesse', 'type': 'SPEED', 'src':'spd','unit':'km/h'});
            }
           if(this.asset.sensorData) for(let sensor of  this.asset.sensorData){
              this.sensors.push(sensor);
            }
            for(let sensor of this.sensors){
              for (let s of this.asset.sensors){
                if(sensor.type === s.type){
                  sensor.src = this.getSensorSrc(s);
                }
              }
            }
          }


          if(!sensor){
            this.sensor = this.sensors[0];
            sensor = this.sensors[0];

            this.createPaths(histoData, 0 ,0);
            this.getAddress();
            let i= 0;
            for(let path of this.paths){
              if(path == undefined || path == null){
                this.paths.splice(i, 1);
              }
              i += 1;
            }
            for(let trajet of this.trajets){
              this.showTrajet(trajet, 1, null)
            }
            this.showPaths();
            this.histoLayer.addTo(this.map);
            this.selectedStopLayer.addTo(this.map)
          }




          if(sensor){
            for(let deviceMsg of dm){
              if(deviceMsg && deviceMsg.data && deviceMsg.data.length>0){
                let result = deviceMsg.data;
                for(let res of result){
                  let realVal = null;

                  let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
                  if (sensor.type && sensor.src && Number.isFinite(res.io[src])) {
                     realVal = res.io[src];
                    if (sensor.family && sensor.family === "ANALOGIC") {
                   
                      if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
                        realVal = this.sensorUtilService.getRealSensorValue(res.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
                      }
                   
                       if(sensor.type == "FUEL_LEVEL")
                       realVal =
   
                                Number(Number((realVal / sensor.max) * 100) .toFixed(2)) ;     
                                  console.log('new realVal',realVal,sensor) 
                    }
                    else if (sensor.family && sensor.family === "BINARY") {
                      if (sensor.ON !== undefined) {
                        if (realVal === sensor.ON)
                          realVal = 1;
                        else
                          realVal = 0;
                      }
                    }
                  }
                 if(Number.isFinite(realVal))
                  data.push([ moment(res.gps_dt).valueOf(),realVal]);
                }
              }
            }
            series.push({
              name: sensor.name,
              data: data,
              tooltip: {
                valueSuffix: sensor.unit
              }
            });
          }
          hcharts.chart(this.canvas.nativeElement, {
            legend: {enabled: false},
            exporting: { enabled: false },
            chart: {
              zoomType: 'x',
              events: {
                load: function () {
                  let self = this;
                  setTimeout(function () {
                    self.reflow();
                  }, 100)
                }
              }
            },
            title: {
              text:''
            },
            xAxis: {
              events: {
                afterSetExtremes: function (evt) {
                }
              },
              type: 'datetime',
              dateTimeLabelFormats: {
                month: '%e. %b',
                year: '%b'
              }
            },
            tooltip: {
              shared: true,
              crosshairs: true
            },
            yAxis:{
              title:''
            },
            series: series
          });
          this.loading.dismiss();
        }else{
          this.loading.dismiss();
          this.presentToast();
        }

      })
    });
  }

  showPaths() {
    let startdate = "";
    let Endate = "";
    let content = "";
    let idstart = "";
    let duree = "", latlang = {};
    let coordinates = [];
    if (this.trajets.length > 0) {
      let oldState;
      let key = 0;
      for(let item of this.trajets) {
        startdate = moment.utc(item.Start.gps_dt).format('DD/MM/YYYY HH:mm:ss');
        Endate = moment.utc(item.End.gps_dt).format('DD/MM/YYYY HH:mm:ss');
        duree = "";
        if (item.duree.day)
          duree += item.duree.day + "day - ";
        duree += item.duree.hour + ":" + item.duree.min + ":" + item.duree.sec;

        if (item.state === 'drive') {
          content = '<div class="map-popup"><div class="popup-heading"><img src="assets/road_global.png" style="width: 17px;height: 17px"/> ' + 'T/S ' + (key + 1) + '/' + this.trajets.length + '</div><div class="popup-details">'
            + '<div><img src="assets/icon-time.png" style="width: 16px;height: 16px"/><b> Date Départ</b> ' + startdate + '</div>'
            + '<div><img src="assets/time_end.png" style="width: 16px;height: 16px"/><b> Date Arrivée</b> ' + Endate + '</div>'
            + '</div>';

          //add Path last End
          if (key > 0) {
            latlang = {
              lat: this.trajets[key - 1].End.loc.coordinates[1],
              lng: this.trajets[key - 1].End.loc.coordinates[0]
            };
            item.coordinates.splice(0, 0, latlang);//push in first position
            item.paths.splice(0, 0, this.trajets[key - 1].End);//push in last position


          }
          if (this.trajets[key + 1]) {
            latlang = {
              lat: this.trajets[key + 1].Start.loc.coordinates[1],
              lng: this.trajets[key + 1].Start.loc.coordinates[0]
            };
            item.coordinates.splice(item.paths.length + 1, 0, latlang);//push in last position
            item.paths.push(this.trajets[key + 1].Start);//push in last position
          }
          let polyline = new L.Polyline(item.coordinates, {
            color: '#0044FA',
            weight: 3,
            myId: "drive_" + (key+1)
          }).addTo(this.histoLayer);
          polyline.bindPopup(content);
          polyline.bindTooltip('T/S ' + (key + 1) + '/' + this.trajets.length, { permanent: false, interactive: true ,className: 'tooltip-marker' });
          coordinates.push(item.coordinates)
          let bounds = new L.LatLngBounds(coordinates);
          this.map.fitBounds(bounds);
        } else {// Stop

          content = '<div class="map-popup"><div class="popup-heading"><img src="assets/stop-higchart.png"  style="width: 24px;height: 24px; vertical-align: middle;"/><b>  Arrêt ' + 'T/S ' + (key+ 1) + '/' + this.trajets.length + ' </b>' + '</div><div class="popup-details">'
            + '<div><img src="assets/icon-time.png" style="width: 16px;height: 16px"/> Date<b> ' + startdate + '</b></div>'
            + '<div ><img src="assets/duree.png" style="width: 16px;height: 16px"/> Durée<b>  ' + duree + '</b></div>'
            + '</div>';


          let stopIcon = L.icon({
            iconUrl: 'assets/Stop.png',
            iconSize: [24, 24], // size of the icon
            iconAnchor: new L.Point(12, 12) // point of the icon which will correspond to marker's location
          });

          idstart = "stop_" + (key+1);
          let marker = L.marker([item.Start.loc.coordinates[1], item.Start.loc.coordinates[0]], {icon: stopIcon});
          marker._leaflet_id = idstart;

          marker.bindPopup(content);
          marker.bindTooltip('T/S ' + (key + 1) + '/' + this.trajets.length, { permanent: false, interactive: true ,className: 'tooltip-marker' });

          marker.addTo(this.histoLayer)
        }
        oldState = item.state;
        key += 1;
      }
    }
  }


  goBack(){
    // Go back to assets
    if(this.canGoBack){
      this.navCtrl.pop();
    }
  }


  logout(){
    this.authService.disconnect().then(()=>{
      this.navCtrl.setRoot(LoginPage);
    })
  }

  goMain(){
    this.navCtrl.push(MainPage, {asset : this.asset, canGoBack: this.canGoBack}, {animate: true, direction: 'back'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }

  goRT(){
    this.navCtrl.push(RealtimePage, {asset : this.asset, canGoBack: this.canGoBack},{animate: true, direction: 'back'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }

  getOdoSensorQuery  (asset) {
    var multiplyRate = 1;
    if (this.sensorOdo) {
      if (this.sensorOdo && this.sensorOdo.maxSrc && this.sensorOdo.max && Number.isFinite(this.sensorOdo.maxSrc) && Number.isFinite(this.sensorOdo.max)) {
        multiplyRate = this.sensorOdo.max / this.sensorOdo.maxSrc
      }
      var query = {$multiply: ["$" + this.sensorOdo.src.replace('rt.', ''), multiplyRate]};
      return query;

    } else {
      return "$io.odo";
    }

  };

  getSensorSrc(sensor){
    let src = sensor.src;
    return src.split('.')[2];
  }

  toggleChart(){
    this.pathListshown = false;
    this.showChart = !this.showChart;
  }

  selectSensor(e){
    this.loadChart(e);
  }

}


// WEBPACK FOOTER //
// ./src/pages/historic/historic.ts